import { createSlice } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

import { STATIONS_STATE } from '../../constants';

import { setStations } from './setStations';
import { updateStations } from './updateStations';
import { setFilteredStations } from './setFilteredStations';
import { setFilteredStationsFilter } from './setFilteredStationsFilter';
import { updateFilteredStations } from './updateFilteredStationts';
import { setFilteredStationsLoadingStatus } from './setFilteredStationsLoadingStatus';
import { resetFilteredStations } from './resetFilteredStations';

import { setSelectedStation } from './setSelectedStation';
import { updateSelectedStation } from './updateSelectedStation';
import { resetSelectedStation } from './resetSelectedStation';
import { setSelectedStationPrices } from './setSelectedStationPrices';

import { setFavouriteStations } from './setFavouriteStations';
import { addFavouriteStations } from './addFavouriteStations';
import { deleteFavouriteStations } from './deleteFavouriteStations';
import { resetDeletingStatus } from './resetDeletingStatus';
import { setAddingFavouriteStationsStatus } from './setAddingFavouriteStationsStatus';

import { setVisibleStations } from './setVisibleStations';
import { setVisibleStationsDisplay } from './setVisibleStationsDisplay';

import { setStationsPriceReport } from './setStationsPriceReport';
import { setStationsPriceReportCreatingStatus } from './setStationsPriceReportCreatingStatus';
import { setStationsPriceReportDownloadStatus } from './setStationsPriceReportDownloadStatus';
import { setStationsPriceReportSettings } from './setStationsPriceReportSettings';
import { updateStationsPriceReportSettings } from './updateStationsPriceReportSettings';
import { setStationsPriceReportSettingsDeletingStatus } from './setStationsPriceReportSettingsDeletingStatus';
import { resetStationsPriceReportSettings } from './resetStationsPriceReportSettings';
import { resetStationsPriceReport } from './resetStationsPriceReport';
import { updateStationsPriceSettingsUpdatingStatus } from './updateStationsPriceSettingsUpdatingStatus';
import { updateSelectedStationOnMap } from './updateSelectedStationOnMap';
import { resetSelectedStationOnMap } from './resetSelectedStationOnMap';

export const initialState: StationsState = {
  stations: {},
  filteredStations: {},
  selectedStation: {},
  favouriteStations: {},
  visibleStations: {},
  stationsPriceReport: {},
  stationsPriceReportSettings: {}
};

export const stationsSlice = createSlice({
  name: STATIONS_STATE,
  initialState,
  reducers: {
    updateStations,

    resetFilteredStations,
    setFilteredStationsFilter,
    resetDeletingStatus,
    setAddingFavouriteStationsStatus,
    updateFilteredStations,
    setFilteredStationsLoadingStatus,

    updateSelectedStation,
    resetSelectedStation,
    updateSelectedStationOnMap,
    resetSelectedStationOnMap,

    setVisibleStations,
    setVisibleStationsDisplay,

    resetStationsPriceReport,
    resetStationsPriceReportSettings,
    updateStationsPriceSettingsUpdatingStatus
  },
  extraReducers: (builder) => {
    setStations(builder);
    setFilteredStations(builder);

    setSelectedStation(builder);
    setSelectedStationPrices(builder);

    setFavouriteStations(builder);
    addFavouriteStations(builder);
    deleteFavouriteStations(builder);
    
    setStationsPriceReport(builder);
    setStationsPriceReportCreatingStatus(builder);
    setStationsPriceReportDownloadStatus(builder);
    setStationsPriceReportSettings(builder);
    updateStationsPriceReportSettings(builder);
    setStationsPriceReportSettingsDeletingStatus(builder);
  }
});

export const stationsActions = stationsSlice.actions;
export const stationsReducer = stationsSlice.reducer;

